import styles from './block-padding.module.scss';

interface Props {
  children?: React.ReactNode;
  maxWidth?: 'small' | 'large' | false;
}

export default function BlockPadding({ children, maxWidth = false }: Props) {
  return (
    <div className={styles.block__padding}>
      <div
        className={styles.inner}
        style={{
          // eslint-disable-next-line no-nested-ternary
          maxWidth: maxWidth === 'small' ? '1130px' : maxWidth === 'large' ? '1360px' : '100%',
        }}
      >
        {children}
      </div>
    </div>
  );
}
